"use client";

import { useEffect } from "react";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Error already logged server-side by AppError.logError()
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h2 className="text-xl font-semibold">Đã xảy ra lỗi</h2>
      <p className="text-gray-500">
        Hệ thống đang gặp sự cố. Vui lòng thử lại sau.
      </p>
      <button
        onClick={reset}
        className="rounded bg-primary px-4 py-2 text-white hover:opacity-90"
      >
        Thử lại
      </button>
    </main>
  );
}
